<template>
  <div class="chartEl">
    <Line v-if="lineChartData" :data="lineChartData" :options="chartOptionsComputed" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

const props = defineProps({
  chartLabels: {
    type: Array,
    required: true
  },
  chartOptions: {
    type: Object,
    default: () => ({})
  },
  chartData: {
    type: Array,
    required: true
  }
})

const lineChartData = ref(null)
const labels = ref([])
const datasets = ref([])

const colour = [
  "#e51313",
  "#13e5e5",
  "#1313e5",
  "#e5e513",
  "#13e513",
  "#efad1e",
  "#e40fc8",
  "#698d2f",
  "#7f2323",
  "#000000"
]

const chartOptionsComputed = computed(() => ({
  responsive: true,
  maintainAspectRatio: true,
  ...props.chartOptions
}))

const setChartData = () => {
  datasets.value = []
  for (let i = 0; i < 9; i++) {
    if (props.chartData[i]) {
      datasets.value.push({
        label: props.chartData[i].name,
        data: props.chartData[i].values,
        fill: false,
        borderColor: colour[i]
      })
    }
  }
}

const fillData = () => {
  // If datasets is empty, add a placeholder to ensure axes render
  const finalDatasets = datasets.value.length > 0 ? datasets.value : [{
    label: 'No data',
    data: [],
    fill: false,
    borderColor: '#cccccc'
  }]

  lineChartData.value = {
    labels: labels.value,
    datasets: finalDatasets
  }
}

const getData = () => {
  labels.value = props.chartLabels
  setChartData()
}

watch(() => props.chartLabels, () => {
  labels.value = props.chartLabels
  fillData()
})

watch(() => props.chartOptions, () => {
  fillData()
})

watch(() => props.chartData, () => {
  setChartData()
  fillData()
})

onMounted(() => {
  getData()
  fillData()
})
</script>

<style scoped>
.chartEl {
  position: relative;
}
</style>
